module.exports = {
  siteTitle: 'Other Coffee',
  heading: 'Other Coffee',
  subHeading:
    "",
};
